import React from 'react';
//import ConnectionIcon from './assets/ConnectionIcon';
import StudentFilledIcon from './assets/StudentFilled';


// import { Container } from './styles';

function CollapsedHeader({isOpen}) {
  function noScroll() {
    window.scrollTo(0, 0);
  }
  
  // add listener to disable scroll
  isOpen && window.addEventListener('scroll', noScroll);
  
  // Remove listener to re-enable scroll
  isOpen && window.removeEventListener('scroll', noScroll);

  const openClass = isOpen ? 'open' : '' 
  return (
    <nav className={`collapsed-header ${openClass}`}>
      <li>
        <ul>
          <a
            href="https://www.academiarafaeltoro.com.br/cursos/"
            className="checkout-menu-header-element"
          >
            Cursos
          </a>
        </ul>
        <ul>
          <a
            href="https://www.academiarafaeltoro.com.br/conteudos/"
            className="checkout-menu-header-element"
          >
            Conteúdos
          </a>
        </ul>
        <ul>
          <a
            href="https://www.academiarafaeltoro.com.br/materiais/"
            className="checkout-menu-header-element"
          >
            Materiais
          </a>
        </ul>
        <ul>
          <a
            href="https://www.academiarafaeltoro.com.br/sobre/"
            className="checkout-menu-header-element"
          >
            Sobre
          </a>
        </ul>
        <ul>
          <a
            href="https://app2.academiarafaeltoro.com.br/auth/login"
            className="checkout-menu-header-element"
          >
            Área do aluno <StudentFilledIcon />
          </a> 
        </ul>
      </li>
    </nav>
  );
}

export default CollapsedHeader;